import { SettingsCustomTableComponent } from './custom_table/settings-custom-table.component';

const SharedSettingsModule =
  angular.module('topbroker.sharedSettings', [])
    .component('settingsCustomTable', SettingsCustomTableComponent)
    .name;

export default SharedSettingsModule;
